const row = "_275rue7l8f";
const actionButtons = "_275atv67fy";
const mobileContainer = "_275m175w5xb";
const mobileTopSection = "_275m118rx01";
const mobileLeftSection = "_275mo2232";
const mobileHeadingCell = "_275mia2woh";
const mobileDateCell = "_275mhaa0hb";
const mobileSharedCell = "_275m15gchif";
const mobileProductCell = "_275m1kik7ke";
const mobileDialogCell = "_275m1bh6udn";
const mobileRightSection = "_275m1ywbgz5";
const mobileStatsCell = "_275mksypsz";

export { actionButtons, mobileContainer, mobileDateCell, mobileDialogCell, mobileHeadingCell, mobileLeftSection, mobileProductCell, mobileRightSection, mobileSharedCell, mobileStatsCell, mobileTopSection, row };
import "./table.item.style.linaria.module.css";
//# sourceMappingURL=table.item.style.js.map
